// src/blogs/PostPermalink.jsx
// Small link icon in a post's meta row. Clicking it puts the post's permalink
// in the address bar (ready to copy) and scrolls the post into place; the
// href is real, so right-click "copy link address" and open-in-new-tab work.
import React from "react";

import { useBlogNavigation } from "./BlogNavContext.js";
import { handlePostLinkClick, postHref } from "./postLinks.js";

export default function PostPermalink({ id }) {
  const { veilNavigate } = useBlogNavigation();
  const href = postHref(id);
  if (!href) return null;

  return (
    <a
      className="post-permalink"
      href={href}
      title="Link to this post"
      aria-label="Link to this post"
      onClick={(event) => handlePostLinkClick(event, id, veilNavigate)}
    >
      <svg
        viewBox="0 0 24 24"
        width="14"
        height="14"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M10 13a5 5 0 0 0 7.07 0l3-3a5 5 0 0 0-7.07-7.07l-1.5 1.5" />
        <path d="M14 11a5 5 0 0 0-7.07 0l-3 3a5 5 0 0 0 7.07 7.07l1.5-1.5" />
      </svg>
    </a>
  );
}
